import { InventorySubMenu, WebFilteringSubMenu } from '../../../utils/enums';
import DomainsIcon from '@svg/domains.svg?react';
import CategoriesIcon from '@svg/categories.svg?react';
import { ReactNode } from 'react';

export const dropdownMenuIcons: {[key: string]: ReactNode} = {
    [WebFilteringSubMenu.DOMAINS]: <DomainsIcon />,
    [WebFilteringSubMenu.CATEGORIES]: <CategoriesIcon />,
    [InventorySubMenu.SERVICES]: <DomainsIcon />,
    [InventorySubMenu.GROUPS]: <DomainsIcon />,
    [InventorySubMenu.ADDRESSES]: <DomainsIcon />,
};